import React from 'react';
import { Globe, MapPin, Plane, TrendingUp, Users } from 'lucide-react';
import { programasSociales } from '../mock';

const iconMap = {
  Globe: Globe,
  MapPin: MapPin,
  Plane: Plane,
  TrendingUp: TrendingUp,
  Users: Users
};

const ProgramasSociales = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Programas y Apoyos</h2>
          <p className="text-gray-600 max-w-3xl mx-auto">
            Iniciativas que impulsan el empleo, la capacitación y el desarrollo laboral en Yucatán. 
            Consulta los programas disponibles y encuentra el apoyo que mejor se adapte a tus necesidades.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {programasSociales.map((programa) => {
            const IconComponent = iconMap[programa.icono];
            return (
              <div
                key={programa.id}
                className="group relative bg-gradient-to-br from-gray-50 to-slate-100 rounded-xl p-6 border border-gray-200 hover:shadow-xl hover:border-[#8B1538] transition-all duration-300 cursor-pointer"
              >
                <div className="flex flex-col h-full">
                  <div className="w-14 h-14 bg-gradient-to-br from-[#8B1538] to-[#6B0F2A] rounded-lg flex items-center justify-center mb-4 shadow-sm group-hover:shadow-md transition-shadow">
                    <IconComponent className="h-7 w-7 text-white" />
                  </div>
                  
                  <h3 className="text-lg font-semibold text-gray-900 mb-2 group-hover:text-[#8B1538] transition-colors">
                    {programa.nombre}
                  </h3>
                  
                  <p className="text-sm text-gray-600 leading-relaxed flex-grow">
                    {programa.descripcion}
                  </p>
                  
                  <div className="mt-4 pt-4 border-t border-gray-200">
                    <button className="text-sm font-medium text-[#8B1538] hover:text-[#6B0F2A] transition-colors flex items-center gap-2 group-hover:gap-3">
                      Conocer más
                      <svg className="w-4 h-4 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProgramasSociales;